import { ImageUploadSettings } from "../constants";

export const PreviewImageUpload: ImageUploadSettings = {
	label: "Önizleme Görseli",
	maxFileSize: "20971520",
	extensions: ["jpeg", "jpg", "png"],
	dimensions: [{ width: 332, height: 332 }]
};

export type PreviewTextSettings = {
	header: {
		label: string;
		placeholder: string;
	};
	previewText: {
		label: string;
		placeholder: string;
	};
	image: {
		label: string
	}
};

export const PreviewTextConstants: Record<string, PreviewTextSettings> = {
	"tr-TR": { 
		header: {
			label: "Başlık",
			placeholder: "Bakımevi Ziyareti ve Sahiplenme Etkinliği"
		},
		previewText: {
			label: "Önizleme Metni",
			placeholder: "Bakımevindeki patili dostlarımızla buluşuyoruz. Sen de belki kalbine dokunan bir bağ kurar, sahiplenme yolculuğuna bir adım atarsın."
		},
		image: {
			label: "Önizleme Görseli"
		}
	},
	"en-US": {
		header: {
			label: "Title",
			placeholder: "Animal Shelter Visit and Adoption Event"
		},
		previewText: {
			label: "Preview Text",
			placeholder: "We're meeting with our furry friends at the shelter. Maybe you'll find a heartwarming connection and take a step towards adoption."
		},
		image: {
			label: "Preview Image"
		}
	}
};
